import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import type { User } from '@/types/user';

interface UserAvatarProps {
  user: Pick<User, 'firstName' | 'lastName' | 'avatar'>;
  size?: 'sm' | 'md' | 'lg';
  showName?: boolean;
  className?: string;
}

const sizeClasses = {
  sm: 'h-6 w-6 text-xs',
  md: 'h-8 w-8 text-sm',
  lg: 'h-10 w-10 text-base',
};

export function UserAvatar({ user, size = 'md', showName = false, className = '' }: UserAvatarProps) {
  const getInitials = (firstName: string, lastName: string) => {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Avatar className={sizeClasses[size]}>
        <AvatarImage src={user.avatar} alt={`${user.firstName} ${user.lastName}`} className="object-cover" />
        <AvatarFallback className="bg-primary/10 text-primary font-medium">
          {getInitials(user.firstName, user.lastName)}
        </AvatarFallback>
      </Avatar>
      {showName && (
        <span className="text-sm font-medium">
          {user.firstName} {user.lastName}
        </span>
      )}
    </div>
  );
}
